export enum Task {
  CreateDirectory = 'create-directory',
  CreateFile = 'create-file',
  ChangeOwner = 'change-owner',
  ChangeGroup = 'change-group',
  ChangePermission = 'change-permission',
  ChangeContent = 'change-content'
}
